import axios from "axios";

const backend = () => import.meta.env.VITE_BACKEND_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function findMappingForUrl(mappings, url) {
  if (!url || !mappings?.length) return null;
  const exact = mappings.find((m) => m.url === url);
  if (exact) return exact;
  try {
    const hostname = new URL(
      url.startsWith("http") ? url : `https://${url}`
    ).hostname.replace(/^www\./, "");
    return mappings.find((m) => m.domain === hostname) || null;
  } catch {
    return null;
  }
}

export function sortMappingsStable(mappings = []) {
  return [...mappings].sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
}

export async function fetchUserMappings(userEmail) {
  const res = await axios.get(`${backend()}/api/metrics/sheet-mapping`, {
    params: { userId: userEmail.toLowerCase() },
    withCredentials: true,
  });
  return sortMappingsStable(res.data.mappings || []);
}

export async function saveSheetMapping({
  userEmail,
  url,
  sheetId,
  tabName,
  sheetName,
  scheduleEnabled = false,
  scheduleTime,
  scheduleTimezone,
  scheduleDayOfWeek,
  scheduleRecurrence,
  nextScheduledAt,
}) {
  await axios.post(
    `${backend()}/api/metrics/sheet-mapping`,
    {
      userId: userEmail.toLowerCase(),
      url,
      domain: null,
      sheetId,
      tabName: tabName || "Sheet1",
      sheetName,
      source: "google",
      scheduleEnabled,
      scheduleTime,
      scheduleTimezone,
      scheduleDayOfWeek,
      scheduleRecurrence,
      nextScheduledAt,
    },
    { withCredentials: true }
  );
}

export async function updateMappingSchedule({
  userEmail,
  url,
  domain,
  sheetId,
  tabName,
  scheduleEnabled,
  scheduleTime,
  scheduleTimezone,
  scheduleDayOfWeek,
  scheduleRecurrence,
  nextScheduledAt,
}) {
  await axios.put(
    `${backend()}/api/metrics/sheet-mapping`,
    {
      userId: userEmail.toLowerCase(),
      url: domain ? undefined : url,
      domain: domain || undefined,
      sheetId,
      tabName: tabName || "Sheet1",
      scheduleEnabled,
      scheduleTime,
      scheduleTimezone,
      scheduleDayOfWeek,
      scheduleRecurrence,
      nextScheduledAt,
    },
    { withCredentials: true }
  );
}

export async function saveMetricsToUserSheet(metrics, sheetId, tabName) {
  await axios.post(
    `${backend()}/api/metrics/save-user-sheet`,
    {
      ...metrics,
      sheetId,
      sheetTabName: tabName || "Sheet1",
    },
    { withCredentials: true, headers: authHeaders() }
  );
}

export function formatSheetSaveError(error) {
  let msg =
    error?.response?.data?.error ||
    error?.message ||
    "Failed to save to Google Sheet.";
  if (msg.includes("Unable to parse range")) {
    return "That sheet tab doesn't exist. Pick a different tab or sheet.";
  }
  if (msg.includes("not found") || msg.includes("Not Found")) {
    return "Sheet not found. It may have been deleted. Pick a new one.";
  }
  if (msg.includes("permission") || msg.includes("Access denied")) {
    return "No permission to write to this sheet. Re-select it with Google connected.";
  }
  return msg;
}
